import { AuthContent, AuthContext } from '@admin/components/auth'
import TextField from '@admin/components/form/textfield'
import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Answer extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    account: PropTypes.object,
    security_questions: PropTypes.array,
    security_question_id: PropTypes.number,
    token: PropTypes.string,
    onBack: PropTypes.func,
    onNext: PropTypes.func
  }

  state = {
    message: null,
    security_question_answer: '',
    status: 'pending'
  }

  _handleBack = this._handleBack.bind(this)
  _handleNext = this._handleNext.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  render() {
    return (
      <AuthContext.Consumer>
        {(authContext) => {
          this._authContext = authContext
          return this._renderContent()
        }}
      </AuthContext.Consumer>
    )
  }

  _renderContent() {
    const question = this._getQuestion()
    const { message } = this.state
    return (
      <AuthContent>
        <div className="maha-auth-form">
          <div className="maha-auth-content">
            <h2><T text="t(Answer your question)" /></h2>
            <p><T text={ question.text } /></p>
          </div>
          { message &&
            <div className="maha-auth-error">
              <T text={ message } />
            </div>
          }
          <div className="ui form">
            <div className="field text-field">
              <TextField { ...this._getAnswer() } />
            </div>
            <div className="field">
              <Button { ...this._getContinue() } />
            </div>
          </div>
          <div className="maha-auth-footer">
            <Button { ...this._getBack() } />
          </div>
        </div>
      </AuthContent>
    )
  }

  _getAnswer() {
    return {
      placeholder: 't(Answer)',
      autocomplete: 'off',
      onChange: this._handleUpdate.bind(this, 'security_question_answer')
    }
  }

  _getBack() {
    return {
      label: 't(Choose a different question)',
      className: 'link',
      handler: this._handleBack
    }
  }

  _getContinue() {
    const { status } = this.state
    return {
      label: 't(Continue)',
      loading: status === 'submitting',
      color: 'blue',
      size: 'large',
      handler: this._handleSubmit
    }
  }

  _getQuestion() {
    const { security_questions, security_question_id } = this.props
    return _.find(security_questions, { id: security_question_id })
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleNext() {
    this.props.onNext()
  }

  _handleSubmit() {
    const { token, security_question_id } = this.props
    const { security_question_answer } = this.state
    this.setState({ status: 'submitting' })
    this.context.network.request({
      endpoint: '/api/admin/activate/security',
      method: 'POST',
      body: {
        token,
        security_question_id,
        security_question_answer
      },
      onSuccess: this._handleNext,
      onFailure: ({ errors }) => {
        this._authContext.shake()
        this.setState({
          message: errors.security_question_answer[0],
          status: 'pending'
        })
      }
    })
  }

  _handleUpdate(key, value) {
    this.setState({
      [key]: value
    })
  }

}

export default Answer
